export const STUDENTS = {
  SET_STUDENTS: 'SET_STUDENTS',
  ADD_STUDENT: 'ADD_STUDENT',
  UPDATE_STUDENT: 'UPDATE_STUDENT',
  REMOVE_STUDENT: 'REMOVE_STUDENT'
}
